import { render } from "./PlanMetrics.vue?vue&type=template&id=0b61843d&scoped=true"
import script from "./PlanMetrics.vue?vue&type=script&lang=js"
export * from "./PlanMetrics.vue?vue&type=script&lang=js"

import "./PlanMetrics.vue?vue&type=style&index=0&id=0b61843d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b61843d"]])

export default __exports__